<template>
  <div ref="el" :style="styles">
    <slot v-bind="{ textRef }" />
  </div>
</template>
<script>
import { currentHeaderHeight } from '../directives/stickyHeader'
import { basketRect } from './EnjoymentDetailBasket.vue'
let zIndex = 1

export default {
  props: {
    separator: {
      type: Boolean,
      default: true
    },
    first: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    animate: {
      default: false
    }
  },
  data() {
    return {
      fixed: false,
      zIndex: zIndex++,
      textEl: null,
      lastScrollY: 0,
      ticking: false,
      scrollDir: 0,
      prevScrollY: 0,
      boundingRect: null
    }
  },
  methods: {
    textRef(el) {
      this.textEl = el
    },
    scroll(lastScrollY) {
      if (lastScrollY < this.prevScrollY) {
        this.scrollDir = -1
      } else {
        this.scrollDir = 1
      }

      this.prevScrollY = lastScrollY

      this.boundingRect = this.$refs.el.getBoundingClientRect()
      /*
      if (this.scrollDir === 1) {
        if (boundingRect.top <= 0) {

        }
      }
      */
    },
    onScrollWatcher() {
      this.lastScrollY = window.scrollY
      this.scroll(this.lastScrollY)
      /*
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.ticking = false
        })

        this.ticking = true
      }
      */
    }
  },
  computed: {
    textHeightDiff() {
      if (!this.textEl || !basketRect.value || isNaN(currentHeaderHeight.value)) {
        return 0
      }

      const textBoundRect = this.textEl.getBoundingClientRect()
      const diff =
        window.innerHeight -
        basketRect.value.height -
        //24 -
        currentHeaderHeight.value -
        textBoundRect.height

      if (diff < 40) {
        return 0
      }

      return diff > 0 ? 0 : diff
    },
    styles() {
      if (!this.animate) {
        return {}
      }

      let opacity = 1
      /*
      const scrollUpTreshold = 300 + currentHeaderHeight.value
      if (this.boundingRect && this.boundingRect.top <= 0) {
        opacity = Math.abs(Math.min(Math.abs(this.boundingRect.top), this.boundingRect.height / 2) / (this.boundingRect.height/2) - 1)
        console.log('opacity 1', opacity)
      } else if (this.boundingRect && this.boundingRect.top > scrollUpTreshold) {
        opacity = 0
        console.log('opacity 2', opacity)
      } else if (this.boundingRect && this.boundingRect.top < scrollUpTreshold && this.boundingRect.top > currentHeaderHeight.value && this.boundingRect.top > 80) {
        opacity = Math.abs((Math.max((this.boundingRect.top - currentHeaderHeight.value), 0) - scrollUpTreshold) / scrollUpTreshold)
        console.log('opacity 3', opacity)
      }
      */

      return {
        position: 'sticky',
        top: this.textHeightDiff + currentHeaderHeight.value / 2.01 + 'px',
        //transform: 'translateY(' +  (currentHeaderHeight.value === 0 ? -80 : 0) + 'px)',
        zIndex: this.zIndex,
        transition: 'top 350ms 50ms ease-in-out',
        willChange: 'top',
        opacity
      }
    }
  },
  mounted() {
    if (!this.animate) {
      return
    }

    this.boundingRect = this.$refs.el.getBoundingClientRect()
    if (this.first) {
      this.zIndex = zIndex = 1
    }
    window.addEventListener('scroll', this.onScrollWatcher)
  },
  unmounted() {
    if (!this.animate) {
      return
    }

    window.removeEventListener('scroll', this.onScrollWatcher)
  }
}
</script>
